// extracted by mini-css-extract-plugin
export var Item = "Item-module--Item--2XGZV";
export var custom = "Item-module--custom--3w4cU";
export var Symbol = "Item-module--Symbol--1LNLY";
export var check = "Item-module--check--1lEJG";